var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1 2.56667C1 2.1933 1 2.00661 1.07266 1.86401C1.13658 1.73857 1.23857 1.63658 1.36401 1.57266C1.50661 1.5 1.6933 1.5 2.06667 1.5H11.9333C12.3067 1.5 12.4934 1.5 12.636 1.57266C12.7615 1.63658 12.8634 1.73857 12.9273 1.86401C13 2.00661 13 2.1933 13 2.56667V3.72484C13 3.8879 13 3.96943 12.9816 4.04615C12.9653 4.11418 12.9383 4.17921 12.9017 4.23885C12.8605 4.30613 12.8029 4.36379 12.6876 4.47909L8.64573 8.52093C8.53047 8.6362 8.4728 8.69387 8.4316 8.76113C8.395 8.8208 8.36807 8.8858 8.35173 8.95387C8.33333 9.0306 8.33333 9.11213 8.33333 9.27513V10.8333L5.66667 13.5V9.27513C5.66667 9.11213 5.66667 9.0306 5.64825 8.95387C5.63191 8.8858 5.60498 8.8208 5.56843 8.76113C5.5272 8.69387 5.46955 8.6362 5.35425 8.52093L1.31242 4.47909C1.19712 4.36379 1.13947 4.30613 1.09824 4.23885C1.06169 4.17921 1.03475 4.11418 1.01842 4.04615C1 3.96943 1 3.8879 1 3.72484V2.56667Z",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterNew);
export default __webpack_public_path__ + "static/media/filterNew.eb8ff9a159650124cb4fc120d23804c7.svg";
export { ForwardRef as ReactComponent };